import React, { useEffect, useMemo } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAllocModel } from "../allocModel";
import { ISCMAllocDetail } from "../allocService";
import { useDictModel } from "@/views/base/dict/dictModel";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useAllocModel();
    const { getTreeNodeName } = useDictModel(() => []);
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    useEffect(() => {
        loadData();
    }, [])

    const columns: ColumnsType<ISCMAllocDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            align: "center",
            render: (t, r, i) => i + 1
        }, {
            title: '商品编号',
            width: 160,
            dataIndex: 'materialCode',
        },
        {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        },
        // {
        //     title: '仓库',
        //     width: 160,
        //     dataIndex: 'warehouseName',
        // }, {
        //     title: '货位',
        //     width: 160,
        //     dataIndex: 'inShelfCode',
        // },
        {
            title: '调拨数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '调拨单号',
            width: 190,
            dataIndex: 'transferCode',
        }, {
            title: '调出站点',
            width: 160,
            dataIndex: 'outShopName',
        }, {
            title: '已出库数量',
            width: 100,
            dataIndex: 'stockIoNum',
        }, {
            title: '出库状态',
            width: 100,
            dataIndex: 'stockOutStatus',
            render: text => text ? getTreeNodeName(text) : ""
        }, {
            title: '出库时间',
            width: 180,
            dataIndex: 'transferOutTime',
        }, {
            title: '调入站点',
            width: 160,
            dataIndex: 'shopName',
        }, {
            title: '已入库数量',
            width: 100,
            dataIndex: 'inStockIoNum',
        }, {
            title: '入库状态',
            width: 120,
            dataIndex: 'stockInStatus',
            render: text => text ? getTreeNodeName(text) : ""
        }, {
            title: '入库时间',
            width: 180,
            dataIndex: 'transferInTime',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "stockAlloc", "roleCodes": roles };
        return getRoleColumns("stockAlloc", "主单", columns, params);
    }, [roles, dataSource]);

    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            bordered
            // rowSelection={{
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     //全部选中时  (存string[])
            //     onSelectAll: (selected, selectedRows, changeRows) => {
            //         let changeRowId = changeRows.map(item => item.id);
            //         selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
            //             : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
            //     },
            //     onSelect: (record) => onRow(record.id),
            // }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content', y: "calc(100vh - 410px)" }}
        />
    )
}